/**************************************************
 * Nombre:       Check_Moto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {useDialogoSeguridad} from "../Hooks/useDialogoSeguridad";
import Formulario_Check_Conductor from "../Formularios/Formulario_Check_Conductor";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import {useEffect, useState} from "react";
import Formulario_Check_Moto from "../Formularios/Formulario_Check_Moto";
import {PowerSettingsNewOutlined, Rule, TaskAlt} from '@mui/icons-material'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarObjLocal} from "../../Servicios/BDLocal/guardarObjLocal";
import {obtenerObjLocal} from "../../Servicios/BDLocal/obtenerObjLocal";
import Tarjeta_Ultima_Lista from "../Tarjetas/Tarjeta_Ultima_Lista";
import {borrarObjLocal} from "../../Servicios/BDLocal/borrarObjLocal";
import {obtenerPlaca} from "../../Utilidades/obtenerPlaca";

const Check_Moto = () => {

    const recargar = () => {
        window.location.reload()
    }

    const {Dialogo, datos} = useDialogoSeguridad()
    const {props, setEntidad, obtenerEntidad, limpiarEntidad} = useFormulario({valoresDefecto: {}})
    const {Cargador, Avisos, iniciarCarga, terminar} = useCargador({logoRedondo: logo, funcionUno: recargar})
    const [ultima, setUltima] = useState(null)


    const subirDatos = async () => {
        let entidad = await obtenerEntidad()
        entidad.placa = obtenerPlaca(entidad.placa)
        entidad.fecha = new Date().getTime()
        entidad.tipo = 'Moto'
        entidad.idConductor = entidad.id
        delete entidad.id

        iniciarCarga()
        let dox = await guardarDoc('listascheckeo', entidad)
        if (dox.res) {
            terminar({aviso: 'Datos correctamente entregados'})
            guardarUltimaLista(entidad)

        } else {
            terminar({aviso: 'No se subio el formulario, intentelo nuevamente', variante: 'error'})
        }
    }


    const salir = () => {
        setUltima({})
        borrarObjLocal({key: 'ultima'})
        borrarObjLocal({key: 'conductor'})
        window.location.reload()
    }

    const guardarUltimaLista = (entidad) => {
        guardarObjLocal({key: 'ultima', obj: entidad})
        setUltima(entidad)
    }

    useEffect(() => {
        setEntidad(datos)
        let ult = obtenerObjLocal({key: 'ultima'})
        if (ult) {
            setUltima(ult)
        }
    }, [datos]);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Dialogo/>

            <Cargador/>

            <Avisos/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 4}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>


                        <Grid container size={12} sx={{justifyContent: 'center', mt: 4, mb: 4}}>
                            <Typography sx={{fontWeight: 800, fontSize: 24}}>Lista de Checkeo Moto</Typography>
                        </Grid>

                        <Grid container size={6}>
                            <Typography>Datos del conductor</Typography>
                        </Grid>

                        <Grid container size={6} sx={{justifyContent: 'flex-end'}}>
                            <Button
                                onClick={() => salir()}
                                color={'secondary'}
                                variant={'outlined'} startIcon={<PowerSettingsNewOutlined/>}>Salir</Button>
                        </Grid>

                        <Grid container size={12} sx={{mt: 2}}>
                            <Formulario_Check_Conductor props={props}/>
                        </Grid>

                        {ultima ?

                            <Grid container size={12} sx={{mt: 4}}>
                                <Tarjeta_Ultima_Lista item={ultima}/>
                            </Grid>
                            :

                            <Grid container size={12} sx={{mt: 4}}>
                                <Formulario_Check_Moto props={props}/>
                            </Grid>

                        }


                        <Grid container size={12} sx={{justifyContent: 'center', mt: 4, mb: 8}}>
                            {ultima ?

                                <Button
                                    onClick={() => setUltima(null)}
                                    color={'secondary'}
                                    variant={'outlined'}
                                    startIcon={<Rule/>}>Nueva Lista</Button>

                                :

                                <Button
                                    color={'secondary'}
                                    sx={{color: '#fff'}}
                                    onClick={() => subirDatos()}
                                    startIcon={<TaskAlt/>}>Subir Lista</Button>

                            }
                        </Grid>

                    </Grid>
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Check_Moto